import React, { useState } from 'react';
// import CompositePage from '../../components/CompositePage';
import CompositePage from '../../components/TopMarketGenreCore';

const REVENUE_TYPE = 'mobile';
export default function MobileGames(props) {
  const { perType } = props;

  return (
    <div>
      <CompositePage perType={perType} revenueType={REVENUE_TYPE} />
    </div>
  );
}
